import type { GetPatientProfileRequest, PatientDto, RequestPatientProfileChangeDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PatientService {
  apiName = 'Default';
  

  getProfile = (input: GetPatientProfileRequest, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PatientDto>({
      method: 'GET',
      url: '/api/app/patient/profile',
      params: { pharmacyLinkId: input.pharmacyLinkId },
    },
    { apiName: this.apiName,...config });
  

  updateProfileAddress = (input: RequestPatientProfileChangeDto, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RequestPatientProfileChangeDto>({
      method: 'PUT',
      url: '/api/app/patient/profile-address',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
